<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="bodymatter">
<section epub:type="division">
<h1 class="part"><a id="page1"></a><strong>PART 1</strong></h1>
<h1 class="part1"><strong><span class="big">SALATO</span> <span class="middle">(SAVORY)</span></strong></h1>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454926474_epub_p01_r1.vue?363aace9